import React from "react";
import { Box, Typography } from "@mui/material";

const PassengerList = React.memo(({ passengers = [], onSelectPassenger }) => {
  if (!passengers.length) {
    return (
      <Typography variant={"caption"} color={"text.secondary"}>
        No passengers for this connection
      </Typography>
    );
  }

  // Sort by seat number and letter
  const sorted = [...passengers].sort((a, b) => {
    const seatA = a.seat || "";
    const seatB = b.seat || "";

    // Extract numbers and letters from seat strings
    const numA = parseInt(seatA.match(/\d+/)?.[0] || "9999", 10);
    const letterA = seatA.match(/[A-Za-z]$/)?.[0] || "Z";

    const numB = parseInt(seatB.match(/\d+/)?.[0] || "9999", 10);
    const letterB = seatB.match(/[A-Za-z]$/)?.[0] || "Z";

    // Sort by number first, then by letter
    if (numA !== numB) return numA - numB;
    return letterA.localeCompare(letterB);
  });

  const renderServices = (services) => {
    if (!Array.isArray(services) || services.length === 0) return "";
    const codes = services
      .map((service) => (typeof service === "string" ? service : service?.code))
      .filter(Boolean);
    return codes.length ? ` - ${codes.join(", ")}` : "";
  };

  return (
    <Box component={"ul"} sx={{ pl: 0, mb: 0, mt: 0, listStyle: "none" }}>
      {sorted.map((p) => (
        <li key={p.id}>
          <Typography
            variant={"caption"}
            onClick={() => onSelectPassenger && onSelectPassenger(p)}
            sx={{ cursor: onSelectPassenger ? "pointer" : "default" }}
          >
            {p.seat && p.seat !== "N/A" ? `Seat ${p.seat} - ` : ""}
            {p.name}
            {(!p.seat || p.seat === "N/A") &&
              (() => {
                if (p.passengerType === "IN") {
                  return "";
                }
                const checkedInText = p.checkedIn
                  ? "Checked in"
                  : "Not checked in";
                const boardedText =
                  typeof p.boarded === "boolean"
                    ? `, ${p.boarded ? "Boarded" : "Not boarded"}`
                    : "";
                return ` - ${checkedInText}${boardedText}`;
              })()}
            {renderServices(p.services)}
          </Typography>
        </li>
      ))}
    </Box>
  );
});

export default PassengerList;
